import type { RouteRecordRaw } from 'vue-router'
import ProjectsDashboardListProjects from '@/views/projects/dashboard/list-projects.vue'

export default [
  { path: '/projects',
    name: 'projects.list',
    component: ProjectsDashboardListProjects
  }
] satisfies RouteRecordRaw[] as RouteRecordRaw[]
